import type { HomeContent } from '@/types'

export const homeContent: HomeContent = {
    page: {
        id: 'home',
        heroEyebrow: "A short note on the sea",
        heroTitle: "The tide asas",
        heroTitleEmphasis: "asasasasas back.",
        heroBody: "s",
        heroButtonLabel: "Read the note",
        introHeading: "A rhythm older than any calendar",
        introBody: "Long before clocks, people living by the sea measured their days by the water. Fishermen waited for it, children raced it, and whole villages learned its moods. The tide is still keeping that same time today, whether or not anyone is watching.",
        highlightsHeading: "How to spend an hour at the shore",
        highlightsBody: "A few small habits that turn a walk along the beach into something you remember.",
        findsHeading: "What the tide leaves behind",
        findsBody: "Every low tide sets out a fresh collection along the sand. Here is what you are most likely to find.",
        quoteText: "WHAT THE HELL",
        quoteAuthor: "PLEASE",
        quoteSource: "HELP and explorer",
        factsHeading: "who are you",
        faqHeading: "what",
        faqBody: "ARE",
        ctaHeading: "who are you",
        ctaBody: "niq",
        ctaButtonLabel: "sssdsd",
        footerText: "biq"
    },
    highlights: [
        { id: 'listen', title: "LAS", body: "Arrive a little early and let the sound of the water settle you. The surf tells you whether the tide ASAS rising or falling long before the sand does." },
        { id: 'wet-line', title: "Walk AS wet line", body: "AS" },
        { id: 'leave-it', title: "AS", body: "AS" }
    ],
    finds: [
        { id: 'kelp', name: "Ribbons of kelp", detail: "Torn loose by the night swell and laid out like dark silk." },
        { id: 'glass', name: "Sea glass", detail: "Old bottles, softened and frosted by years of patient tumbling." },
        { id: 'razor', name: "Razor shells", detail: "Long and smooth, often found in pairs near the low water mark." },
        { id: 'pools', name: "Tide pools", detail: "Small worlds of anemones, shrimp and periwinkles waiting for the sea to return." }
    ],
    facts: [
        { id: 'daily', value: "902", label: "kur po don ti" },
        { id: 'interval', value: "223", label: "pse pe don" },
        { id: 'moon', value: "902 m2", label: "kesekulqe" },
        { id: 'fundy', value: "002 m", label: "ksl" }
    ],
    faqs: [
        { id: 'two-tides', question: "YOU", answer: "soosnnsnsn" },
        { id: 'spring', question: "MAKE", answer: "Nothing to do with the season. When the sun and moon line up, around the new and full moon, their pull combines and the tides rise higher and fall lower than usual." },
        { id: 'best-time', question: "WOA", answer: "hshhwed wao" }
    ]
}
